import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const API = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash;
    const sessionId = hash?.split('session_id=')?.[1]?.split('&')?.[0];

    if (!sessionId) {
      navigate('/login');
      return;
    }

    fetch(`${API}/api/auth/google/callback`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session_id: sessionId }),
    })
      .then(r => r.json())
      .then(data => {
        if (data.access_token) {
          login(data.access_token, {
            id: data.user_id,
            email: data.email,
            full_name: data.full_name,
            role: data.role,
            picture: data.picture,
          });
          // Landlords and professionals always go to profile setup after Google/Apple OAuth
          const needsProfile = data.role === 'landlord' || data.role === 'working-professional';
          if (needsProfile) navigate('/profile-setup');
          else navigate(data.role === 'landlord' ? '/landlord-dashboard' : '/student-dashboard');
        } else {
          navigate('/login');
        }
      })
      .catch(() => navigate('/login'));
  }, []);

  return (
    <div className="min-h-screen bg-sky-50 flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[#094f6f] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-gray-600 font-medium">Completing sign in…</p>
      </div>
    </div>
  );
}
